import { render, staticRenderFns } from "./PotentialResourcesView.vue?vue&type=template&id=ef0b3e28&scoped=true&"
import script from "./PotentialResourcesView.vue?vue&type=script&lang=js&"
export * from "./PotentialResourcesView.vue?vue&type=script&lang=js&"
import style0 from "./PotentialResourcesView.vue?vue&type=style&index=0&lang=css&"
import style1 from "./PotentialResourcesView.vue?vue&type=style&index=1&id=ef0b3e28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef0b3e28",
  null
  
)

export default component.exports